export enum FIleType {
  All = 0,
  Folder = 1,
  Files = 2,
  FilesAndFolder = 3,
  Video = 4,
  Photo = 5,
  Document = 6,
  Contacts = 7,
  UserSpecific = 8,
  DocumentText = 9,
  MedicalContacts = 10,
}
